import { ListItem, ListItemButton, listItemIconClasses, Theme } from '@mui/material'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { FC, ReactNode } from 'react'

type SpotlightResultItemProps = {
    onClick: () => void
    selected?: boolean
    children: ReactNode
}

/** Shared wrapper for spotlight search result items */
export const SpotlightResultItem: FC<SpotlightResultItemProps> = ({ onClick, selected, children }) =>
    <ListItem disablePadding>
        <ListItemButton
            onClick={onClick}
            selected={selected}
            sx={{
                borderRadius: C1BorderRadius.regular,
                gap: 1,
                px: 2,
                '&:hover': {
                    backgroundColor: 'primary.extraLight',
                    color: 'primary.dark',
                    [`& .${listItemIconClasses.root}`]: {
                        color: 'primary.dark',
                    },
                },
                '&:focus-visible': {
                    boxShadow: (theme: Theme): string => `inset 0 0 0 2px ${theme.palette.primary.main}`,
                    backgroundColor: 'common.white',
                    color: 'text.primary',
                },
            }}
        >
            {children}
        </ListItemButton>
    </ListItem>
